import type { NativeTag } from 'types/track'

/**
 * TODO: Demo placeholder — the backend doesn't expose which tags were applied
 * by auto-tagging yet. Marks a deterministic subset of tags as AI so all four
 * tag variants (color dot, color + AI, AI only, plain) are visible during
 * design review. Replace with the real per-assignment flag before shipping.
 */
export const isAiTagPlaceholder = (tag: NativeTag): boolean => tag.id % 3 === 0
